import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_sales_return,
  get_sales_return,
  update_sales_return,
} from "../../../../Controllers/Sales/Returns";
import { get_invoice } from "../../../../Controllers/Sales/Invoices";
import forms from "../../../../Data/Forms/Sales/Returns/forms";
import headers from "../../../../Data/Forms/Sales/Returns/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Salesreturnstable from "../../../../Data/Forms/Sales/Returns/table";
import dayjs from "dayjs";

const SalesReturnsForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);
  const [invoiceData, setInvoiceData] = useState(null);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [existingInvoice, setExistingInvoice] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState(null);

  const focus = useRef([]);

  const [details, setDetails] = useState([
    {
      description: null,
      options: [],
      name: "",
      batch: "",
      unit: "",
      unit_name: "",
      quantity: "",
      sale_price: "",
      discount_price: "",
      discount_percentage: "",
      free: "",
      stock: 0,
      tax: 0,
      total: 0,
      unit_details_options: [],
    },
  ]);

  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: dayjs(),
    payment_status: 2,
    payment_types: ["Cash"],
    payments: {
      Cash: { amount: 0 },
      "Debit card": { amount: 0 },
      "Credit card": { amount: 0 },
      "Bank transfer": { amount: 0 },
      "Online payment": { amount: 0 },
      Cheque: { amount: 0 },
    },
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const handleInvoiceNumberChange = async (number) => {
    console.log("Invoice typed:", number);
    //setInvoiceNumber(number);

    if (!number) return;

    const res = await get_invoice({ id: number });
    if (res?.status) {
      console.log("ressss", res.data)
      setInvoiceData(res.data);
      setInvoiceDetails(res.data.details || []);

      let customerOption;
      let updatedValues;

      if (res.data.customer) {
        const customer = res.data.customer;
        customerOption = {
          value: customer._id,
          label:
            customer.name && customer.phone
              ? `${customer.name} (${customer.phone})`
              : customer.name || customer.phone || "",
        };

        updatedValues = [...values];
        updatedValues[0].options[0].form.value = customer._id;
        updatedValues[0].options[0].form.options = [customerOption];
      } else {
        customerOption = {
          value: null,
          label: "Walk-in-customer",
        };

        updatedValues = [...values];
        updatedValues[0].options[0].form.value = null;
        updatedValues[0].options[0].form.options = [customerOption];
      }

      totals.subtotal = res.data?.subtotal;
      totals.taxamount = res.data?.taxamount;
      totals.discount = res.data?.discount;
      totals.delivery = res.data?.delivery;
      totals.total = res.data?.total;

      setValues(updatedValues);

      setTotals({ ...totals });
    } else {
      toast.error(res.message || "Invoice not found");
      setInvoiceData(null);
      setInvoiceDetails([]);
    }
  };

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            focus.current[`description${i}`].current.focus();
          } else if (!v?.sale_price) {
            document.getElementById(
              `sale_price${i}`
            ).textContent = `Sale price is required`;
            focus.current[`sale_price${i}`].current.focus();
          } else if (!v?.quantity) {
            document.getElementById(
              `quantity${i}`
            ).textContent = `Quantity is required`;
            focus.current[`quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`sale_price${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};

    let count_totals = 0;

    if (totals?.delivery_status == 2 && !totals?.delivery_date) {
      document.getElementById(
        `delivery_date`
      ).textContent = `Delivery Date is required`;
      focus.current[`delivery_date`].current.focus();
    } else if (totals?.payment_status && !totals?.payment_types?.length) {
      document.getElementById(
        `payment_types`
      ).textContent = `Payment type is required`;
      focus.current[`payment_types`].current.focus();
    } else {
      if (totals?.delivery_status == 2) {
        document.getElementById(`delivery_date`).textContent = ``;
      }
      if (totals?.payment_status) {
        document.getElementById(`payment_types`).textContent = ``;
      }
      count_totals++;
    }

    //payments  validation
    if (count_totals) {
      let total_payment_types = totals?.payment_types?.length;
      let count_payment_types = 0;

      if (totals?.payment_types?.length > 0) {
        totals?.payment_types?.map((v, i) => {
          if (count_payment_types == i) {
            if (!totals?.payments?.[v]?.amount) {
              document.getElementById(`${v}`).textContent = `${v} is required`;
              focus.current[`${v}`].current.focus();
            } else {
              document.getElementById(`${v}`).textContent = ``;
              count_payment_types++;
            }
          }
        });

        if (count_payment_types == total_payment_types) {
          params = {
            status: true,
            data: {
              ...tabledata,
              id: id ? id : "",
              source: "Sales Returns",
              subtotal: totals?.subtotal,
              taxamount: totals?.taxamount,
              discount: totals?.discount,
              delivery: totals?.delivery,
              delivery_status: totals?.delivery_status,
              delivery_date: totals?.delivery_date,
              payment_status: totals?.payment_status,
              payment_types: totals?.payment_types,
              payments: totals?.payments,
              total: totals?.total,
            },
          };
          return params;
        } else {
          params = {
            status: false,
            data: null,
          };

          return params;
        }
      } else {
        params = {
          status: true,
          data: {
            ...tabledata,
            id: id ? id : "",
            subtotal: totals?.subtotal,
            taxamount: totals?.taxamount,
            discount: totals?.discount,
            delivery: totals?.delivery,
            delivery_status: totals?.delivery_status,
            delivery_date: totals?.delivery_date,
            payment_status: totals?.payment_status,
            payment_types: totals?.payment_types,
            payments: totals?.payments,
            total: totals?.total,
          },
        };

        return params;
      }
    }
  };

  const formdata = async (data) => {
    if (data?.status) {
      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        const tabletotalvalidation = totalsvalidation(
          tabledetailsvalidation?.data
        );

        if (tabletotalvalidation?.status) {
          setButtonLoader(true);
          console.log("uoihansas", tabledetailsvalidation?.data)
          const sales_return = id
            ? await update_sales_return(tabletotalvalidation?.data)
            : await create_sales_return(tabletotalvalidation?.data);
          if (sales_return?.status) {
            // if (id) {
            navigate(-1);
            // }
            toast?.success(sales_return?.message);
            setButtonLoader(false);
          } else {
            setButtonLoader(false);
            if (sales_return?.status_code == 403) {
              window.location.href = "/unauthorized";
            } else {
              toast?.error(sales_return?.message);
            }
          }
        }
      }
    }
  };

  const handleData = (sales_return) => {

    let customer = sales_return?.customer?._id
      ? sales_return?.customer?._id
      : null;
    let number = sales_return?.number ? sales_return?.number : "";
    let date = sales_return?.date ? sales_return?.date : "";
    let due_date = sales_return?.due_date ? sales_return?.due_date : "";
    let status = sales_return?.status ? sales_return?.status : 0;

    let customer_option = sales_return?.customer?._id
      ? [
        {
          value: sales_return?.customer?._id,
          label:
            sales_return?.customer?.name && sales_return?.customer?.phone
              ? sales_return?.customer?.name +
              " (" +
              sales_return?.customer?.phone +
              ")"
              : sales_return?.customer?.name
                ? sales_return?.customer?.name
                : sales_return?.customer?.phone
                  ? sales_return?.customer?.phone
                  : "",
        },
      ]
      : null;

    values[0].options[0].form.value = customer;
    values[0].options[0].form.options = customer_option;
    values[0].options[1].form.value = number;
    values[0].options[2].form.value = date;
    values[0].options[3].form.value = due_date;
    values[0].options[4].form.value = status;

    let data = [];

    sales_return?.details?.map((value, index) => {
      let stock = value?.description?.stock;

      if (value?.unit != value?.description?._id) {
        value?.inventory_unit_details?.map((v, i) => {
          if (value?.unit == v?._id) {
            stock = v?.stock;
          }
        });
      }

      data?.push({
        id: value?._id,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        already_ordered_quantity: stock,
        stock: stock,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.inventory_unit_details,
        conversion: value?.conversion,
        sales_return_price: value?.sales_return_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        free: value?.free,
        tax: value?.tax,
        barcode: value?.barcode,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        expiry_date: value?.expiry_date,
        tax_amount: value?.tax_amount,
        total: value?.total,
      });
    });

    let payment_types = [];
    let payments = {};
    sales_return?.payments?.map((v, i) => {
      payment_types?.push(v?.name);
      payments[v?.name] = { id: v?._id, amount: v?.amount };
    });
    totals.subtotal = sales_return?.subtotal;
    totals.taxamount = sales_return?.taxamount;
    totals.discount = sales_return?.discount;
    totals.delivery = sales_return?.delivery;
    totals.delivery_status = sales_return?.delivery_status;
    totals.delivery_date = sales_return?.delivery_date;
    totals.payment_status = sales_return?.payment_status;
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.total = sales_return?.total;

    setValues([...values]);
    setDetails([...data]);
    setTotals({ ...totals });
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const sales_return = await get_sales_return(data);
      if (sales_return?.status) {
        setInvoiceNumber(sales_return?.data?.number);
        handleData(sales_return?.data);
      } else {
        toast?.error(sales_return?.message);
      }
    } else {
      values[0].options[2].form.value = new Date();
      // values[0].options[3].form.value = new Date();

      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;

      setValues([...values]);
      setTotals({ ...totals });
      setLoader(false);
    }
  };

  const fetchExistingInvoice = async () => {
    const number = parseInt(invoiceNumber);
    const invoiceResponse = await get_invoice({ number });

    setInvoiceData(invoiceResponse.data);

    if (invoiceResponse?.status) {
      const updatedDetails = details.map((detail) => {
        const invoiceItem = invoiceResponse.data.details.find(
          (item) => item.description._id === detail.description
        );

        return {
          ...detail,
          already_ordered_quantity: invoiceItem ? invoiceItem.quantity : 0,
        };
      });

      setDetails(updatedDetails);

      setExistingInvoice(invoiceResponse.data);
    }
  };

  useEffect(() => {
    fetchExistingInvoice();
  }, [invoiceNumber]);

  useEffect(() => {
    fetchData();
  }, []);

  const selectHandlers = {
    number: handleInvoiceNumberChange,
  };

  console.log("billing returns index.js", details)

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Form
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
          selectHandlers={selectHandlers}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Salesreturnstable
                id={id}
                details={details}
                setDetails={setDetails}
                invoiceData={invoiceData}
                totals={totals}
                setTotals={setTotals}
                ref={focus}
              />
            </Formdata>
          </Bodycomponent>
        </Form>
      </Loadercomponent>
    </Header >
  );
};

export default SalesReturnsForm;
